import { create } from 'zustand';

type ToastType = 'error' | 'success' | 'info';

interface Toast {
  id: string;
  type: ToastType;
  message: string;
}

interface ToastState {
  toasts: Toast[];
  addToast: (type: ToastType, message: string, duration?: number) => void;
  removeToast: (id: string) => void;
}

// 生成唯一ID
const generateId = () => Math.random().toString(36).substring(2, 9);

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],

  addToast: (type, message, duration = 3000) => {
    const id = generateId();
    set((state) => ({
      toasts: [...state.toasts, { id, type, message }],
    }));

    // 自动移除
    setTimeout(() => {
      get().removeToast(id);
    }, duration);
  },

  removeToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    }));
  },
}));

// 便捷方法
export const toast = {
  error: (message: string, duration?: number) => useToastStore.getState().addToast('error', message, duration),
  success: (message: string, duration?: number) => useToastStore.getState().addToast('success', message, duration),
  info: (message: string, duration?: number) => useToastStore.getState().addToast('info', message, duration),
};